/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@-webkit-keyframes opacity-pulse{0%,100%{opacity:1}50%{opacity:.5}}@keyframes opacity-pulse{0%,100%{opacity:1}50%{opacity:.5}}.blink[_ngcontent-%COMP%]{-webkit-animation:1.5s infinite opacity-pulse;animation:1.5s infinite opacity-pulse}"];
export { styles as styles };
